import EventBus from "eventing-bus";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';

import './index.css';
import { web3 } from '../../store/web3';
import { networkId, message } from '../../store/config';
import { login } from '../../store/actions/Auth';
import { connectWalletSuccess, disconnectWallet } from '../../store/actions/Auth.js';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      error: null,
      showWalletDropdown: false,
    };
  }

  async componentDidMount() {
    try {
      const walletData = JSON.parse(localStorage.getItem('connectWalletSuccess'));
      if (walletData && window.ethereum) {

        const provider = window.ethereum;

        const accounts = await provider.request({ method: 'eth_accounts' });
        if (provider && accounts.length > 0) {
          const address = accounts[0];
          this.props.connectWalletSuccess({
            address: walletData.address,
            network: walletData.network,
            provider: window.ethereum
          });

        } else {
          this.props.disconnectWallet();
        }
      }
    } catch (e) {
      this.props.disconnectWallet();
    }

  }

  connectWallet = async () => {
    try {
      if (typeof window.ethereum === 'undefined') {
        EventBus.publish('info', 'MetaMask not found. Please install MetaMask!');
        return;
      }

      const provider = window.ethereum;
      const netId = await web3.eth.net.getId();

      if (netId !== networkId) {
        EventBus.publish('info', message);
      }

      const accounts = await provider.request({ method: 'eth_requestAccounts' });
      const address = accounts[0];

      provider.on('accountsChanged', () => {
        window.location.reload();
      });

      provider.on('chainChanged', () => {
        window.location.reload();
      });

      this.props.connectWalletSuccess({
        address,
        network: netId,
        provider,
      });

      localStorage.setItem('connectWalletSuccess', JSON.stringify({
        address,
        network: netId,
        providerType: 'injected'
      }));

      EventBus.publish('info', 'Wallet connected!');
    } catch (error) {
      console.error("Wallet connection error:", error);
      this.setState({ error: error.message });
    }
  };

  disconnect = () => {
    this.props.disconnectWallet();
    localStorage.removeItem('connectWalletSuccess');
    EventBus.publish('info', 'Wallet disconnected');
    this.setState({ showWalletDropdown: false });
  }

  toggleWalletDropdown = () => {
    this.setState((prevState) => ({
      showWalletDropdown: !prevState.showWalletDropdown
    }));
  };

  render() {
    const { sticky, publicAddress } = this.props;

    return (
      <div className={`mp-club-nav ${sticky ? 'sticky-nav' : ''}`}>
        <nav className='navbar navbar-expand-lg sidenav' id="sidenav-1" data-mdb-hidden="false">
          <div className='container-fluid'>
            <div className="inner-container">
              <button onClick={() => this.setState(prev => ({ isOpen: !prev.isOpen }))} className='navbar-toggler' type='button'>
                <i className='fa fa-bars' aria-hidden='true'></i>
              </button>
              <div className={`collapse navbar-collapse nav-links ${this.state.isOpen ? 'show' : ''}`} id='navbarSupportedContent'>
                <ul className='navbar-nav sidenav-menu'>
                  <li className='nav-item'>
                    <Link className='nav-link' smooth="true" to='./#home'>Home</Link>
                  </li>
                  <li className='nav-item'>
                    <HashLink className='nav-link' smooth to='#rewards'>Rewards</HashLink>
                  </li>
                  <li className='nav-item'>
                    <HashLink className='nav-link' smooth to='#tokenomics'>Tokenomics</HashLink>
                  </li>
                  <li className='nav-item'>
                    <a className='nav-link' href='https://webgl.modernpokerclub.com/' target="_blank" rel="noopener noreferrer">Play Game</a>
                  </li>
                  <li className='nav-item'>
                    <Link className='nav-link' to="/bridge">Bridge</Link>
                  </li>
                </ul>

                {
                  publicAddress ?
                    <>
                      <div className="wallet-dropdown">
                        <button
                          className="nav-btn btn-style-one desktop-btn"
                          type="button"
                          onClick={this.toggleWalletDropdown}
                        >
                          <span>{publicAddress.substring(0, 5) + '.....' + publicAddress.slice(-4)}</span>
                          {this.state.showWalletDropdown || (
                            <i className="icon">
                              <svg fill="#764503" height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330">
                                <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
                              c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
                              s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
                              </svg>
                            </i>
                          )}
                        </button>

                        {this.state.showWalletDropdown && (
                          <div className="wallet-menu">
                            <button onClick={this.disconnect}>Disconnect</button>
                          </div>
                        )}
                      </div>
                    </>
                    :
                    <button onClick={this.connectWallet} className="nav-btn btn-style-one desktop-btn" type="button">
                      <span>Connect Wallet</span>
                    </button>
                }

              </div>
            </div>
          </div>
        </nav>
      </div >
    );
  }
}

const mapStateToProps = ({ Auth }) => {
  let { address } = Auth;
  return {  publicAddress: address };
};

const mapDispatchToProps = {
  connectWalletSuccess,
  disconnectWallet,
  login
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
